// react and js
import { React } from "react";
import { Outlet } from "react-router-dom";

// mui
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Box, Stack } from "@mui/material";

// components

// hooks
import defines from "../hooks/defines";

// layouts
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";

// pages

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function Public() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

  // Calculate header height (accounting for mobile double-row header)
  const headerHeight = isDesktop ? defines.headerHeightDesktop : defines.headerHeightMobile;

  return (
    <Box
      id="auto-scroll-container"
      sx={{
        marginTop: `${headerHeight}px`,
        maxHeight: `calc(100vh - ${headerHeight}px)`,
        overflowY: "scroll",
        overflowX: "hidden",
        // Custom scrollbar styling
        "&::-webkit-scrollbar": {
          width: "16px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#e0e0e0",
          borderRadius: "6px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888888",
          borderRadius: "6px",
          border: "2px solid #e0e0e0",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#666666",
        },
        // Firefox scrollbar styling
        scrollbarWidth: "thin",
        scrollbarColor: "#888888 #e0e0e0",
      }}
    >
      <PublicHeader />

      <Stack
        direction="column"
        spacing={0}
        sx={{
          minHeight: `calc(100vh - ${headerHeight}px)`,
          display: "flex",
          position: "relative",
          overflow: "hidden",
          // Animated futuristic gradient background
          background: `
            linear-gradient(
              -45deg,
              #0f0f0f,
              #1a1a2e,
              #16213e,
              #0f0f0f,
rgb(20, 40, 77),
rgb(30, 58, 107),
              #0f0f0f
            )
          `,
          backgroundSize: "400% 400%",
          animation: "futuristicGradient 20s ease infinite",
          // CSS animation keyframes for gradient
          "@keyframes futuristicGradient": {
            "0%": {
              backgroundPosition: "0% 50%",
            },
            "50%": {
              backgroundPosition: "100% 50%",
            },
            "100%": {
              backgroundPosition: "0% 50%",
            },
          },
          // Animated white spot overlay
          "&::before": {
            content: '""',
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "-25%",
            left: "-25%",
            pointerEvents: "none",
            background: `
              radial-gradient(
                circle at 50% 50%,
                rgba(255, 255, 255, 0.08) 0%,
                rgba(255, 255, 255, 0.04) 15%,
                rgba(255, 255, 255, 0.02) 25%,
                transparent 35%
              )
            `,
            animation: "movingSpot 15s ease-in-out infinite",
            zIndex: 1,
          },
          // Animation for the moving white spot
          "@keyframes movingSpot": {
            "0%": {
              transform: "translate(0%, 0%) scale(1)",
            },
            "25%": {
              transform: "translate(-30%, 20%) scale(1.2)",
            },
            "50%": {
              transform: "translate(20%, -30%) scale(0.8)",
            },
            "75%": {
              transform: "translate(-20%, -20%) scale(1.1)",
            },
            "100%": {
              transform: "translate(0%, 0%) scale(1)",
            },
          },
        }}
      >
        <Box sx={{ position: "relative", zIndex: 2 }}>
          <Outlet />
        </Box>

        <Box sx={{ flexGrow: 1, position: "relative", zIndex: 2 }} />

        <Box sx={{ position: "relative", zIndex: 2 }}>
          <PublicFooter />
        </Box>
      </Stack>
    </Box>
  );
}
